import React, { useEffect } from 'react';
import $ from 'jquery';



export const PaiementClientTableRow = ({ invoice}) => {
    useEffect(() => {
        $('[data-toggle="tooltip"]').tooltip();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);



    return (
        <div className="card p-2 mt-1">
            <div className="row gx-2 gy-1 align-items-center">
                <div className="col col-md-3 col-lg-2">
                    <div className="h5 ls-1 my-auto text-truncate">{invoice.number}</div>
                </div>
                <div className="col-auto col-md-2">
                    <div className="row gx-2">
                        <div className="col col-xl-12">
                            <div className="h5 ls-1 my-auto o-70 text-truncate">{invoice.recipientName}</div>
                        </div>
                        {/* <div className="col col-xl-6">
                            <div className="h5 ls-1 my-auto o-70 text-truncate">type utilisateur</div>
                        </div> */}
                    </div>
                </div>
                <div className="col-auto col-md-2 text-md-right">
                    <div className="h5 ls-1 my-auto o-70 container-tiny ml-auto">{new Intl.DateTimeFormat('fr-FR').format(invoice.created)}</div>
                </div>
                <div className="col-auto col-md-2 text-md-right">
                    <div className="h5 ls-1 my-auto container-press ml-auto">{new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(invoice.amount)}</div>
                </div>
                {/* <div className="col-auto col-md-2 text-md-right">
                    <div className="h5 ls-1 my-auto container-press ml-auto">Partenaire</div>
                </div> */}
                <div className="col-12 d-md-none">
                    <hr className="my-0" />
                </div>
                { !invoice.paid ?
                    <div className="col-12 col-md-3 col-xl ml-auto flex-row justify-content-md-end">
                        {
                            (() => {
                                switch(invoice.status){
                                    case "new":
                                    case "retry3":
                                    case "retry7":
                                        return <div className="badge alert-bagde text-uppercase btn-alert-danger font-weight-bold my-auto py-2 px-3 lh-1 mr-auto mr-md-0 text-truncate"><span className="aling-middle text-truncate">en Paiement</span></div>;

                                    case "canceled":
                                        return <div className="badge alert-bagde text-uppercase btn-dim font-weight-bold my-auto py-2 px-3 lh-1 mr-auto mr-md-0 text-truncate"><span className="aling-middle text-truncate">Annulé</span></div>;
                                    
                                    case "unpaid":
                                        return <div className="badge alert-bagde text-uppercase btn-alert-danger font-weight-bold my-auto py-2 px-3 lh-1 mr-auto mr-md-0 text-truncate"><span className="aling-middle text-truncate">Echoué</span></div>;

                                    default:
                                        return <div className="badge alert-bagde text-uppercase btn-dim font-weight-bold my-auto py-2 px-3 lh-1 mr-auto mr-md-0 text-truncate"><span className="aling-middle text-truncate">Inconnu</span></div>;
                                }

                            })()
                        }
                        
                        {/* <a href={pdfUrl} type="button" className="btn btn-icon btn-stage-info shadow-none p-1 rounded-sm ml-2" data-toggle="tooltip" title="Voir la facture" data-template='<div class="tooltip tooltip-white-info" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2"></div></div>'>
                            <i className="eva eva-file-text-outline align-middle align-middle h4 lh-1 m-auto"></i>
                        </a> */}
                        {/* <button type="button" className="btn btn-icon btn-stage-info shadow-none p-1 rounded-sm ml-2" data-toggle="tooltip" title="Écrire un commentaire" data-template='<div class="tooltip tooltip-white-info" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2"></div></div>'>
                            <i className="eva eva-message-square-outline align-middle h4 lh-1 m-auto"></i>
                        </button> */}
                        {/* <button type="button" className="btn btn-icon btn-stage-info shadow-none p-1 rounded-sm ml-2" data-toggle="tooltip" title="Écrire un commentaire" data-template='<div class="tooltip tooltip-white-info" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2"></div></div>'></button> */}
                        {/* <a href={"#"} target="_blank" rel="noopener noreferrer" className="dropdown-item fs-3 px-2 rounded-sm"><i className="eva eva-file-text-outline align-middle fs-sm lh-1 mr-2"></i><span className="align-middle o-70 o-100--hover">Voir la facture</span></a> */}
                    </div>
                    :
                    <div className="col-12 col-md-3 col-xl ml-auto flex-row justify-content-md-end">
                        <div className="badge alert-bagde text-uppercase btn-dim font-weight-bold my-auto py-2 px-3 lh-1 mr-auto mr-md-0 text-truncate"><span className="aling-middle text-truncate">Paiement effectué</span></div>
                        <a href={invoice.pdfUrl} type="button" className="btn btn-icon btn-stage-info shadow-none p-1 rounded-sm ml-2" data-toggle="tooltip" title="Voir la facture" data-template='<div class="tooltip tooltip-white-info" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2"></div></div>'>
                            <i className="eva eva-file-text-outline align-middle align-middle h4 lh-1 m-auto"></i>
                        </a>
                        {/* <button type="button" className="btn btn-icon btn-stage-info shadow-none p-1 rounded-sm ml-2" data-toggle="tooltip" title="Voir le reçu" data-template='<div class="tooltip tooltip-white-info" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2"></div></div>'>
                            <i className="eva eva-file-text-outline align-middle h4 lh-1 m-auto"></i>
                        </button>
                        <button type="button" className="btn btn-icon btn-stage-info shadow-none p-1 rounded-sm ml-2" data-toggle="tooltip" title="Écrire un commentaire" data-template='<div class="tooltip tooltip-white-info" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2"></div></div>'>
                            <i className="eva eva-message-square-outline align-middle h4 lh-1 m-auto"></i>
                        </button> */}
                    </div>
                }
            </div>
        </div>
    );
};